import {
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Pagination,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authAxios from "setups/axios";
import { fetchOfficersList } from "slices/officers";
import { toastMessage } from "utils/toastMessage";
const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

const filterStyle = {
  width: "200px",
  margin: "0px 5px",
};

const UserSelection = ({ open, handleOpenClose }) => {
  const dispatch = useDispatch();
  const { officers } = useSelector((state) => state.officers);
  const { user } = useSelector((state) => state.user);
  let updatedUsers = officers?.map((user) => ({
    SAP_ID: user.SAP_ID,
    scanEnabled: user.scanEnabled,
    areaName: user.areaName,
    areaCode: user.areaCode,
    regionName: user.regionName,
    regionCode: user.regionCode,
    name: user?.name,
    zone: user?.zone,
    territoryName: user?.territories[0]?.name,
    territoryCode: user?.territories[0]?.territoryCode,
  }));

  const [personName, setPersonName] = React.useState([]);
  const [selectedZone, setSelectedZone] = React.useState([]);
  const [selectedRegion, setSelectedRegion] = React.useState([]);
  const [selectedArea, setSelectedArea] = React.useState([]);

  const [coverage, setCoverage] = React.useState("");
  const [dropDownData, setDropDownData] = React.useState([]);
  const [code, setCode] = React.useState("");
  const [soList, setsoList] = React.useState([]);
  const [reload, setReload] = React.useState("");
  const [message, setMessage] = React.useState("");

  const [totalPages, setTotalPages] = React.useState(1);
  const [currentPage, setCurrentPage] = React.useState(1);

  const [selectedUser, setSelectedUser] = React.useState(updatedUsers);

  const [zone, setZone] = React.useState([]);
  const [region, setRegion] = React.useState([]);
  const [area, setArea] = React.useState([]);

  useEffect(() => {
    if (!user?._id) return;
    dispatch(fetchOfficersList(user.SAP_ID));
    setReload("");
  }, [user, reload]);

  // let updatedUsers = officers?.map((user) => ({
  //   SAP_ID: user.SAP_ID,
  //   scanEnabled: user.scanEnabled,
  //   areaName: user.areaName,
  //   areaCode: user.areaCode,
  //   regionName: user.regionName,
  //   regionCode: user.regionCode,
  //   name: user.name,
  //   zone: user.zone,
  //   territoryName: user.territories[0].name,
  //   territoryCode: user.territories[0].territoryCode,
  // }));

  const uniqueZones = Array.from(
    updatedUsers.reduce((acc, { zone }) => {
      if (zone) acc.add(zone);
      return acc;
    }, new Set())
  );

  let columns = useMemo(() => [
    {
      headerName: "SAP ID",
      flex: 1,
    },
    {
      headerName: "NAME",
      flex: 1,
    },
    {
      headerName: "TERRITORY",
      flex: 1,
    },
    {
      headerName: "IS ASSIGNED",
      flex: 1,
    },
  ]);

  useEffect(() => {
    console.log(
      "selzone1",
      updatedUsers.length,
      selectedUser.length,
      selectedZone
    );
    const uniqueRegions = Array.from(
      updatedUsers
        .filter((user) => selectedZone?.includes(user.zone))
        .reduce((acc, { regionName }) => {
          if (regionName) acc.add(regionName);
          return acc;
        }, new Set())
    );
    setRegion(uniqueRegions);
    setSelectedUser(
      updatedUsers?.filter((user) => selectedZone?.includes(user.zone))
    );
    // setSelectedUser(
    //   updatedUsers?.filter((user) => selectedZone?.includes(user.zone))
    // );
  }, [selectedZone, message]);

  console.log("selzone", selectedZone, selectedUser);

  const uniqueRegions = Array.from(
    updatedUsers.reduce((acc, { regionName }) => {
      if (regionName) acc.add(regionName);
      return acc;
    }, new Set())
  );

  useEffect(() => {
    const uniqueAreas = Array.from(
      updatedUsers
        .filter((user) => selectedRegion.includes(user.regionName))
        .reduce((acc, { areaName }) => {
          if (areaName) acc.add(areaName);
          return acc;
        }, new Set())
    );
    setArea(uniqueAreas);
    setSelectedUser(
      updatedUsers.filter((user) => selectedRegion.includes(user.regionName))
    );
  }, [selectedRegion, message]);

  useEffect(() => {
    setSelectedUser(
      updatedUsers.filter((user) => selectedArea.includes(user.areaName))
    );
  }, [selectedArea, message]);

  console.log("upda", updatedUsers);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(typeof value === "string" ? value.split(",") : value);
  };

  const handleZoneChange = (event) => {
    const zone = event.target.value;
    setSelectedZone(zone);
  };

  const handleRegionChange = (event) => {
    const region = event.target.value;
    // console.log("seler", region);
    // let updatedRegion = [...selectedRegion];
    // if (Array.isArray(region)) {
    //   region.forEach((item) => {
    //     if (!updatedRegion.includes(item)) {
    //       updatedRegion.push(item);
    //     }
    //   });
    // } else {
    //   const index = updatedRegion.indexOf(region);
    //   if (index === -1) {
    //     updatedRegion.push(region);
    //   } else {
    //     updatedRegion.splice(index, 1);
    //   }
    // }
    setSelectedRegion(region);
  };

  const handleAreaChange = (event) => {
    const area = event.target.value;
    // let updatedArea = [...selectedArea];
    // if (Array.isArray(area)) {
    //   area.forEach((item) => {
    //     if (!updatedArea.includes(item)) {
    //       updatedArea.push(item);
    //     }
    //   });
    // } else {
    //   const index = updatedArea.indexOf(area);
    //   if (index === -1) {
    //     updatedArea.push(area);
    //   } else {
    //     updatedArea.splice(index, 1);
    //   }
    // }
    setSelectedArea(area);
  };

  console.log("sele", JSON.stringify(selectedRegion));

  const handledata = async (data) => {
    const foundObject = updatedUsers.find((obj) => obj.SAP_ID === data.SAP_ID);
    if (foundObject) {
      foundObject.scanEnabled = !foundObject.scanEnabled;
      setSelectedUsers((prev) => {
        let newList = prev.filter((obj) => obj.SAP_ID !== foundObject.SAP_ID);
        if (newList.length === prev.length) {
          newList = [...newList, foundObject];
        }
        return newList;
      });
    }
  };

  // useEffect(async () => {
  //   let obj = {
  //     coverage: coverage,
  //     code: code,
  //   };
  //   const response = await authAxios()({
  //     url: `/api/v1/getSoLIST`,
  //     method: "POST",
  //     data: obj,
  //   });
  //   console.log("response", response?.data?.soList);
  //   setsoList(response?.data?.soList);
  //   setMessage("");
  // }, [code, reload, message]);

  // useEffect(async () => {
  //   const response = await authAxios()({
  //     url: `/api/v1/getOfficers/${coverage}`,
  //     method: "GET",
  //   });
  //   console.log("response", response?.data?.data);
  //   setDropDownData(response?.data?.data);
  // }, [coverage]);

  const handleSubmit = async (data) => {
    const response = await authAxios()({
      url: `/api/v1/scan/user/access`,
      method: "PUT",
      data: [data],
    });
    setReload(data?._id);
    setMessage(response?.data?.message);
    toastMessage(response?.data?.message, "success");
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  console.log("object", selectedZone);

  return (
    <>
      <div
        style={{
          backgroundColor: "#F4F4F4",
          padding: "1rem",
          marginRight: "1rem",
          lineHeight: "2rem",
          borderRadius: "5px",
        }}
      >
        <div>
          <p
            style={{
              fontSize: "18px",
              fontWeight: "bolder",
              color: "#0E132F",
              fontWeight: "700",
              fontFamily: "Poppins",
            }}
          >
            Survey
          </p>
        </div>
        <div
          style={{
            width: "100%",
            border: "1.5px solid grey",
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "1rem",
          }}
        >
          <Button variant="contained" onClick={handleOpenClose}>
            View Surveys
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "1rem",
          }}
        >
          <FormControl sx={{ m: 1, width: "30%" }}>
            <InputLabel id="demo-multiple-chip-label">Zone</InputLabel>
            <Select
              labelId="demo-multiple-chip-label"
              id="demo-multiple-chip"
              multiple
              value={selectedZone}
              onChange={(e) => handleZoneChange(e)}
              input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
            >
              {uniqueZones?.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, width: "30%" }}>
            <InputLabel id="demo-multiple-chip-label">Region</InputLabel>
            <Select
              labelId="demo-multiple-chip-label"
              id="demo-multiple-chip"
              multiple
              value={selectedRegion}
              onChange={(e) => handleRegionChange(e)}
              input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
            >
              {region.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, width: "30%" }}>
            <InputLabel id="demo-multiple-chip-label">Area</InputLabel>
            <Select
              labelId="demo-multiple-chip-label"
              id="demo-multiple-chip"
              multiple
              value={selectedArea}
              onChange={(e) => handleAreaChange(e)}
              input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
            >
              {area?.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        {/* <div>
          <Select
            defaultValue={""}
            onChange={(e) => setCoverage(e.target.value)}
            displayEmpty
            style={filterStyle}
          >
            <MenuItem value={""} selected disabled>
              Select Coverage
            </MenuItem>
            <MenuItem value={"ZONE"}>ZONE Wise</MenuItem>
            <MenuItem value={"REGION"}>REGION Wise</MenuItem>
            <MenuItem value={"AREA"}>AREA Wise</MenuItem>
          </Select>
          {coverage == "ZONE" ? (
            <Select
              defaultValue={""}
              onChange={(e) => setCode(e.target.value)}
              displayEmpty
              style={filterStyle}
            >
              <MenuItem value={""} selected disabled>
                Select Zone
              </MenuItem>
              {dropDownData.map((n, i) => (
                <MenuItem key={i} value={n.regionCode}>
                  {n.SAP_ID} ({n.regionCode})
                </MenuItem>
              ))}
            </Select>
          ) : (
            <></>
          )}
          {coverage == "AREA" ? (
            <Select
              defaultValue={""}
              onChange={(e) => setCode(e.target.value)}
              displayEmpty
              style={filterStyle}
            >
              <MenuItem value={""} selected disabled>
                Select Area
              </MenuItem>
              {dropDownData.map((n, i) => (
                <MenuItem key={i} value={n.areaCode}>
                  {n.SAP_ID} ({n.areaName})
                </MenuItem>
              ))}
            </Select>
          ) : (
            <></>
          )}
          {coverage == "REGION" ? (
            <Select
              defaultValue={""}
              onChange={(e) => setCode(e.target.value)}
              displayEmpty
              style={filterStyle}
            >
              <MenuItem value={""} selected disabled>
                Select Region
              </MenuItem>
              {dropDownData.map((n, i) => (
                <MenuItem key={i} value={n.regionCode}>
                  {n.SAP_ID} ({n.regionName})
                </MenuItem>
              ))}
            </Select>
          ) : (
            <></>
          )}
        </div> */}

        <TableContainer
          component={Paper}
          sx={{
            maxHeight: "60vh",
            overflowY: "auto",
            marginTop: "1rem",
          }}
        >
          <Table>
            {columns && columns.length > 0 ? (
              <TableHead>
                <TableRow>
                  {columns.map((item, idx) => (
                    <TableCell
                      align="left"
                      sx={{ fontWeight: "bolder" }}
                      key={idx}
                    >
                      {item.headerName}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            ) : null}

            <TableBody>
              {selectedZone || selectedRegion || selectedArea
                ? selectedUser && selectedUser.length > 0
                  ? selectedUser?.map((d) => (
                      <TableRow key={d?._id}>
                        {console.log("selzone2")}
                        <TableCell align="left">{d?.SAP_ID ?? "-"}</TableCell>
                        <TableCell align="left">{d?.name ?? "-"}</TableCell>
                        <TableCell align="left">
                          {d?.territoryName ? d?.territoryName : "-"}
                        </TableCell>
                        <TableCell align="left">
                          <span
                            style={{
                              color: d?.scanEnabled ? "darkgray" : "#12a4de",
                              fontWeight: d?.scanEnabled ? "normal" : "bold",
                            }}
                          >
                            Not Assigned
                          </span>
                          <Switch
                            checked={d?.scanEnabled}
                            onChange={() => handleSubmit(d)}
                          />
                          <span
                            style={{
                              color: d?.scanEnabled ? "#12a4de" : "darkgrey",
                              fontWeight: d?.scanEnabled ? "bold" : "normal",
                            }}
                          >
                            Assigned
                          </span>
                        </TableCell>
                      </TableRow>
                    ))
                  : updatedUsers?.map((d) => (
                      <TableRow key={d?._id}>
                        {console.log("selzone3")}
                        <TableCell align="left">{d?.SAP_ID ?? "-"}</TableCell>
                        <TableCell align="left">{d?.name ?? "-"}</TableCell>
                        <TableCell align="left">
                          {d?.territoryName ? d?.territoryName : "-"}
                        </TableCell>
                        <TableCell align="left">
                          <span
                            style={{
                              color: d?.scanEnabled ? "darkgray" : "#12a4de",
                              fontWeight: d?.scanEnabled ? "normal" : "bold",
                            }}
                          >
                            Not Assigned
                          </span>
                          <Switch
                            checked={d?.scanEnabled}
                            onChange={() => handleSubmit(d)}
                          />
                          <span
                            style={{
                              color: d?.scanEnabled ? "#12a4de" : "darkgrey",
                              fontWeight: d?.scanEnabled ? "bold" : "normal",
                            }}
                          >
                            Assigned
                          </span>
                        </TableCell>
                      </TableRow>
                    ))
                : null}
              {/* {updatedUsers && updatedUsers?.length > 0 ? (
                updatedUsers?.map((d) => (
                  <TableRow key={d?._id}>
                    <TableCell align="left">{d?.SAP_ID ?? "-"}</TableCell>
                    <TableCell align="left">{d?.name ?? "-"}</TableCell>
                    <TableCell align="left">
                      {d?.territoryName ? d?.territoryName : "-"}
                    </TableCell>
                    <TableCell align="left">
                      <span
                        style={{
                          color: d?.scanEnabled ? "darkgray" : "#12a4de",
                          fontWeight: d?.scanEnabled ? "normal" : "bold",
                        }}
                      >
                        Not Assigned
                      </span>
                      <Switch
                        checked={d?.scanEnabled}
                        onChange={() => handleSubmit(d)}
                      />
                      <span
                        style={{
                          color: d?.scanEnabled ? "#12a4de" : "darkgrey",
                          fontWeight: d?.scanEnabled ? "bold" : "normal",
                        }}
                      >
                        Assigned
                      </span>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <Box sx={{ textAlign: "left", pt: 1 }}>
                  <Typography variant="h6" sx={{ p: 1 }}>
                    No Data.
                  </Typography>
                </Box>
              )} */}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <Grid justifyContent={"center"} container p={1}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Grid> */}

        {/* <Grid justifyContent={"center"} container p={1}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Grid> */}
      </div>
    </>
  );
};

export default UserSelection;
